module.exports = __webpack_public_path__ + "static/img/enterprise-garden-hover.1722f992.png";